'use client'

import { Builder, withChildren } from '@builder.io/react'

import { spacingBuilderInputs } from '@src/utils/builder.util'

import { Container } from './Container'
import { Container as ContainerOld } from './Container.old'

Builder.registerComponent(withChildren(ContainerOld), {
  name: 'Container',
  hideFromInsertMenu: true,
  noWrap: true,
  image: 'https://unpkg.com/@tabler/icons@2.44.0/icons/box-margin.svg',
  inputs: [
    spacingBuilderInputs.innerSpacing,
    spacingBuilderInputs.outerSpacing,
    {
      name: 'includedChildren',
      type: 'array',
      hideFromUI: true,
      subFields: [
        {
          name: 'item',
          type: 'uiBlocks',
          defaultValue: [],
        },
      ],
      defaultValue: [
        {
          item: [],
        },
      ],
    },
  ],
})

Builder.registerComponent(withChildren(Container), {
  name: 'v2: Container',
  noWrap: true,
  image: 'https://unpkg.com/@tabler/icons@2.44.0/icons/box-margin.svg',
  inputs: [
    spacingBuilderInputs.outerSpacing,
    spacingBuilderInputs.innerSpacing,
    {
      name: 'fill',
      friendlyName: 'Fill horizontal space',
      type: 'boolean',
      defaultValue: false,
    },
    {
      name: 'includeContentPadding',
      friendlyName: 'Include content padding',
      type: 'boolean',
      defaultValue: true,
      showIf: (properties) => !properties.get('fill'),
    },
    {
      name: 'rounded',
      type: 'boolean',
      defaultValue: false,
    },
    {
      name: 'backgroundColor',
      type: 'color',
    },
    {
      name: 'includedChildren',
      type: 'array',
      hideFromUI: true,
      subFields: [
        {
          name: 'item',
          type: 'uiBlocks',
          defaultValue: [],
        },
      ],
      defaultValue: [
        {
          item: [],
        },
      ],
    },
  ],
})
